import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { NewTicket } from '../../model/types';
import { isSSR } from '../../utils/helpers';

enableStaticRendering(isSSR());

export class ActiveTicketStore {
    activeTicket: NewTicket;
    constructor() {
        this.activeTicket = null;

        // Call it here
        makeAutoObservable(this);
    }

    setActiveTicket = (ticket: NewTicket): void => {
        // console.warn('SETTING xxx', ticket);
        this.activeTicket = ticket;
    };
}
